import CustomerFeatures from './CustomerFeatures'

export default CustomerFeatures
